<script lang="ts">
    import { onMount } from "svelte";

    import DropdownIcon from "../icons/DropdownIcon.svelte";
    import DropdownIconRegular from "../icons/DropdownIconRegular.svelte";
    import Divider from "./Divider.svelte";
    import IconImg from "./IconImg.svelte";
    import Subline from "./Subline.svelte";
    export let icon: any = null;
    export let heading: string = "params heading is required";
    export let small: boolean = false;
    export let auto_open: boolean = false;
    export let justify_heading: string = "space-between";

    let open: boolean = false;
    let contentHeight: number = 0;
    let content: HTMLElement;
    let dropdownIcon: HTMLElement;

    let overflow = false;

    onMount(() => {
        auto_open && toggleDrowndown();
    });

    const toggleDrowndown = () => {
        if (open) {
            contentHeight = 0;
        } else {
            contentHeight = content.scrollHeight;
        }
        open = !open;

        // animate overflow with delay
        let timeout = overflow ? 0 : 250;
        setTimeout(() => {
            overflow = !overflow;
        }, timeout);
    };
</script>

<div class="dropdown" class:open>
    <div
        class="title"
        class:small
        style:justify-content={justify_heading}
        on:click={toggleDrowndown}
    >
        <Subline>
            {#if icon}
                <IconImg svg={icon} size=".8em" />
            {/if}
            {heading}
        </Subline>
        <div class="dropdown-icon" bind:this={dropdownIcon}>
            <IconImg svg={DropdownIconRegular} />
        </div>
    </div>
    <!-- <Divider gap="0" /> -->
    <div
        class="content"
        style="--contentHeight: {contentHeight}px"
        bind:this={content}
        class:overflow
    >
        <div class="inner">
            <slot />
        </div>
    </div>
</div>

<style lang="scss">
    @import "./src/vars";
    .dropdown {
        .title {
            cursor: pointer;
            display: flex;
            // justify-content: space-between;
            align-items: center;
            &.small {
                :global(.subline) {
                    font-size: 1.5rem !important;
                }
            }
        }

        &.open {
            .dropdown-icon {
                transform: rotate(0.5turn);
            }
        }
        .dropdown-icon {
            transform-origin: center;
            transform: rotate(0turn);
            transition: 0.5s;
            margin-left: 1.5em;
        }
        .content {
            margin-top: 1em;
            height: var(--contentHeight);
            overflow: hidden;
            transition: height 0.25s ease-in-out, border-radius 0.25s ease-in-out;
            margin-bottom: 1em;
            // border: 1px solid $green;
            background-color: $grayDark2;
            border-radius: 0.5em;

            :global(body.light) & {
                background-color: $grayLight2;
            }
            &.overflow {
                overflow: visible;
            }
            .inner {
                padding: 1.5em;
            }
        }
        :global(.subline) {
            margin-bottom: 0 !important;
        }
    }
</style>
